import { combineReducers } from "@reduxjs/toolkit";
import providerAuth from "../components/auth-provider/slice/providerAuth";
import providerChat from "../components/provider-chat/slice/providerChatSlice";
import providerChatList from "../components/provider-chatList/slice/providerChatListSlice";
import providerInfo from "../components/provider-panel/slice/providerPanelSlice";
import providerService from "../components/provider-panel/slice/providerPanelServiceSlice";
import providerNavigation from "../components/provider-navbar/slice/providerNavigationSlice";
import providerListing from "../components/provider-listing/slice/listingSlice";
import providerTickets from "../components/provider-tickets/slice/providerTicketSlice";
import providerImages from "../components/provider-panel/slice/providerPanelImageSlice";
import providerVideos from "../components/provider-panel/slice/providerPanelVideoSlice";
import providerAppointments from "../components/provider-panel/slice/providerPanelAppointmentSlice";
import providerWorktime from "../components/provider-panel/slice/providerPanelWorktimeSlice";
import providerPaymentSetting from "../components/provider-panel/slice/providerPaymentSettingSlice";
import providerRateReview from "../components/provider-panel/slice/providerPanelRateReviewSlice";
import providerPlans from "../components/provider-panel/slice/providerPanelPlansSlice";
import providerClientDetailsModel from "../components/provider-client-details-model/slice/provider-clientDetailsModel";
import providerStripePaymentSetting from "../components/provider-panel/slice/providerStripePaymentSlice";
import providerDashboard from "../components/provider-panel/slice/providerPanelDashboardSlice";
// import providerChatNotifications from "../components/provider-header/slice/providerChatNotificationSlice";

const providerRootReducer = {
  providerAuth,
  providerChat,
  providerChatList,
  providerInfo,
  providerService,
  providerNavigation,
  providerListing,
  providerTickets,
  providerImages,
  providerVideos,
  providerAppointments,
  providerWorktime,
  providerPaymentSetting,
  providerRateReview,
  providerPlans,
  providerClientDetailsModel,
  providerStripePaymentSetting,
  providerDashboard
  // providerChatNotifications
};

export default providerRootReducer;
